<template>
  <VContent>
    <VContainer fill-height>
      <VLayout
              style="{max-width:500px;}"
              align-content-center
              mx-auto
              wrap>
        <VFlex xs12 sm8 offset-sm2 md5 offset-md4>
          <BaseCard>
            <VCardTitle>
              <span class="title font-weight-light">
                Reset password
              </span>
            </VCardTitle>
            <VContainer>
              <VFlex xs12 v-if="newpasswordrequired">
                  <VTextField
                          v-model="username"
                          name="email"
                          label="Username or Email"
                          outlined
                  />

                  <VTextField
                          v-model="generatedpassword"
                          name="email"
                          label="Username or Email"
                          outlined
                  />
                  <VTextField
                          v-model="newpassword"
                          name="newpassword"
                          label="New Password - Letters, Numbers, Capital"
                          outlined
                  />

              </VFlex>
                <VFlex xs12>
                    <BaseBtn @click="changePassword()">Reset</BaseBtn>
                </VFlex>
            </VContainer>
            <VCardActions>

            </VCardActions>
          </BaseCard>
        </VFlex>
      </VLayout>
    </VContainer>
  </VContent>
</template>

<script>
    // Utilities
    import BaseBtn from "../../components/BaseBtn";
    import {
      mapActions,
      mapMutations
    } from 'vuex'
    ///auth/inviteconfirm?code=Qf7XRD0Z&username=bribrink3@gmail.com
    export default {
      components: {BaseBtn},
      data () {
            const data = {
              generatedpassword:false,
              //newPassword:undefined,
              reseting:false,
              username:undefined,
              newpassword:undefined,
              loading:false,
              show:false,
              newpasswordrequired:true
            }
            return data
        },
        name: 'InviteConfirm',
        mounted(){
          if(!this.$route.query.code || !this.$route.query.username){
            this.$router.push('/');
          } else {
            this.generatedpassword = this.$route.query.code;
            this.username = this.$route.query.username;
            this.submit()
          }
        },
        methods: {
          ...mapActions('cognito', ['signInUser', 'userPassword']),
          ...mapMutations(['setSnackbar']),
          submit () {
            let em = this;
            this.signInUser({
              username: this.username,
              password: this.generatedpassword
            }).then((data) => {
                  if(data.challengeName === "NEW_PASSWORD_REQUIRED"){
                      em.newpasswordrequired = true
                  }
                  console.log(data, data.challengeName)
                  this.setSnackbar({
                    type: 'success',
                    msg: `Successfully signed in user ${this.email}`
                  })
                })
                .catch(res => {
                  this.setSnackbar({
                    type: 'error',
                    msg: res.message
                  })
                })
                .finally(() => {

                })
          },
          changePassword(){
            this.loading = true;
            let em = this;
            let args={
              url:em.$store.state.url + 'api/auth/respondtoauthchallenge',
              method:"POST",
              data:{
                clientid:this.$store.state.cognito.user.pool.clientId,
                session:this.$store.state.cognito.user.Session,
                newpassword:this.newpassword,
                username:this.username
              }
            }
            this.$store.dispatch('openFetch',args).then(async res=>{
              em.loading=false;
              console.log(res)
              em.submitFinal(em.username,em.newpassword)
              em.reseting = true;
            }).catch(e=>{
              console.log(e);
              em.loading=false;
            })
          },
          submitFinal (username,password) {
            let em = this;
            this.signInUser({
              username: username,
              password: password
            })
                .then(() => {
                  this.setSnackbar({
                    type: 'success',
                    msg: `Successfully signed in user ${this.email}`
                  })
                  em.$router.push('/dashboard')
                })
                .catch(res => {
                  this.setSnackbar({
                    type: 'error',
                    msg: res.message
                  })
                })
                .finally(() => {
                  em.$store.dispatch('refreshAuth')
                })
          },
          tempRes(){
            let g = {
              AccessToken: "eyJraWQiOiJ5SVBjcFZkWXpnMmRDbkdjYzFtSytmYnU1Q3FmeDRZcFpzMU5TTEZyTDNFPSIsImFsZyI6IlJTMjU2In0.eyJzdWIiOiI1YzFkZGM4My01ZmUzLTQ3YmEtOWY3NC1mMWIwMmE5NmU4ODgiLCJkZXZpY2Vfa2V5IjoidXMtd2VzdC0yXzM3NDEyNjBlLWVjY2UtNDRkOS05MzFhLWRjYjVjNDhlYzMwNiIsImV2ZW50X2lkIjoiZTg1MjZhYjItYzQxYS00MDVhLWIxNWEtMzliNmZhODdmY2ZjIiwidG9rZW5fdXNlIjoiYWNjZXNzIiwic2NvcGUiOiJhd3MuY29nbml0by5zaWduaW4udXNlci5hZG1pbiIsImF1dGhfdGltZSI6MTU3MjY3NzUzMSwiaXNzIjoiaHR0cHM6XC9cL2NvZ25pdG8taWRwLnVzLXdlc3QtMi5hbWF6b25hd3MuY29tXC91cy13ZXN0LTJfM2QzSklENjBHIiwiZXhwIjoxNTcyNjgxMTMxLCJpYXQiOjE1NzI2Nzc1MzEsImp0aSI6ImFjOTY3YjI0LTk5MTgtNDhlMy1iZjM3LTBjZTliMjJhNzM3NSIsImNsaWVudF9pZCI6IjR1NnJmZHZmcTJpOGVuYjc4c204dDlmMWwiLCJ1c2VybmFtZSI6IjVjMWRkYzgzLTVmZTMtNDdiYS05Zjc0LWYxYjAyYTk2ZTg4OCJ9.bHCz2UyWbYz_9RBbsEdDo_80f2MaUJhJKt8wy_C274G4WGe3_u7twQoQOVcRuiLMjtvwdH5lp59Mxou34wLZ52y0j9-HW6sm9s4sJ90-8WL2xhUzZ-D6uTmqZZOPHIwolD-o5MK9Ff6RUhUN53EVH4qL2ivMc5rxlGeMLREyWjmGgdrX8O3UUgGNPxYIMgG218T6ZAc21vsihLiIHrAv8Pis8x0yBCfgSunBY9cSOocOd2sSwvaJynFufup65FoveP1lzd8mX-RBtV74dAhBD6h7a5nPwPS6V_tSugMwAEnWbJO0uNyGhg8gWm0_myK5twOZNmU49aFwM6s_o9EJzQ",
              ExpiresIn: 3600,
              IdToken: "eyJraWQiOiJsRDYwSWhjTEZVR1BPOWdkWUJZY0hiN2M0Q25zd3RJZnZqV2RxVXVcL3drdz0iLCJhbGciOiJSUzI1NiJ9.eyJzdWIiOiI1YzFkZGM4My01ZmUzLTQ3YmEtOWY3NC1mMWIwMmE5NmU4ODgiLCJhdWQiOiI0dTZyZmR2ZnEyaThlbmI3OHNtOHQ5ZjFsIiwiZXZlbnRfaWQiOiJlODUyNmFiMi1jNDFhLTQwNWEtYjE1YS0zOWI2ZmE4N2ZjZmMiLCJ0b2tlbl91c2UiOiJpZCIsImF1dGhfdGltZSI6MTU3MjY3NzUzMSwiaXNzIjoiaHR0cHM6XC9cL2NvZ25pdG8taWRwLnVzLXdlc3QtMi5hbWF6b25hd3MuY29tXC91cy13ZXN0LTJfM2QzSklENjBHIiwiY29nbml0bzp1c2VybmFtZSI6IjVjMWRkYzgzLTVmZTMtNDdiYS05Zjc0LWYxYjAyYTk2ZTg4OCIsImV4cCI6MTU3MjY4MTEzMSwiaWF0IjoxNTcyNjc3NTMxLCJlbWFpbCI6ImJyaWJyaW5rM0BnbWFpbC5jb20ifQ.wPILjizEhX4FK9rGbTiR1ZWzKluNWpV2X5esGn0w5issJTtuHAP_8ol5bvnDYTN3xMN2-GKmjUAzp6NQfwumTg-jcY_5FAqxqDA0bOW9RvjGzlTgujDJenWQ-wNvsQiWLmdQGnE7F9toXBHxyZPNx9lsT8ITKd0JLbAiP4559JoUhrN8mKy-huj5za4dczEc4oAJ7Fq1f7CuDwHDOdC_4OMm58BgiN9L3GPjVtxyxEV5bSK9vZ8-8-Y8NWU3pXR2XiYALKrRLzJE2l2diW0PD0XndPYd4ILzNem4jnCJuvT1GQFUaUzYvyYoIgs0J49DEgWCBSFoe05s2WZVU5Ts-w",
              NewDeviceMetadata:{
                DeviceGroupKey: "-9IVVAJxu"
              },
              DeviceKey: "us-west-2_3741260e-ecce-44d9-931a-dcb5c48ec306",
              RefreshToken: "eyJjdHkiOiJKV1QiLCJlbmMiOiJBMjU2R0NNIiwiYWxnIjoiUlNBLU9BRVAifQ.Vz5OqT5ehEQy6iZrtfO7gljH9hb9y_fY2ocIuKc2UhmOqRsYk9lyLyFGdgKTqH1RMM3gBpiEnxXYe7XzEuRKgy_1nxWCxYX6VCBAe7N6BkcnLYl5wIi9wiwucGtdGfIduP86SCyUPpESfeLrYI8xoy9WBugsteMZsxHm4ZFOj2d1bIvXrUvnG9fX_MbOVcR3OZN-TnMwpIpi6_x5Xy8tCPTQTUhEKrW-D6pP98RVkQO94NyW_82eTsknSoFQpKX81WONTopNXoSepLEL2aS78gyxglLD-wLiYsHUA5SICQEhH4SXGYynbdOST2kwFYBN1AeuBXuS8cYjd1sF0UWatA.giGVsF1AL9BPNCLq.H7vOs1npo6kEvbyI4exoI72tv5uCiKm8d-iMYxHQPCy11wWYmzOROM2MojsHSdQ2PB8hlaIN6pGz2kkpyH0JtGnlERcEofhnw5cTdo-oCk_C1BiFgUWOyG6Wd5qu3q3iH1mlNbrR_w3fcMaesM7Pi18VUx0z56FEB0V3J2y7IWnMsiMlpkPH--ephVgRmBrHAT0VxSWBk7qkQT5AZKufo-AFan5SOTfhjpjrxpYWv8qFPN5Qlz_731sw3vgH6LYdLwNqz5cDhQ3B0NfntOwpO3NqbzfvZa2mLEZvEknqja9mJDZPAgouCUElbLybnaF5mT8h63Um9FR-XR7roOzW9raSt3ha96JghZtzB8bgFeIciVSKB7MfE-8uinIIHK-YtbinqztpRunNr3R0JgbRq7umbzpiLLvd8BSBPA7Y9RT_c0PzHqYHee2Cqiizwt5kzNcEWneNiLiULJFHvzM8SJsLXx2b29WwHBaJdBu_vJkqPbUE1P0pdm54M7KR1boa-Quejxd0PFwWbgtVpBVoNMtlIE8SF-3Q4rXunFLf5g_v4Gbm5e04J6Cyq6SVQhhkFQwo9Eycku5XK8gMmgXESooUZT_cmphxbrow9pq4GYFm6gVPJDSCEj1-S1ZF8Cq0uAcaUeYK6bxm4kkQSf2Vai_zyVghwIjiMebXSwEyMUemAPVZ-D4SPQvQnB81GZrw-lckNzdhGne-PCChGQLB6GtHXUJ-0vshc3zXg2i0P-mZdbZjzt_MYLwvNx0DxvUAccxZRuQusz8tEYBwzdajINrSmniVvfpaoQeX_thodQUYjqTbU8OU4SUIZqpmuUngqMxbPxVtMJ7CVQeRGoNhH_5YyKrBYDIu9JH7P4vev08RTM9yLsOaoqIgW42KcBldgu5rAra6AybkvbOiFOIf_H6k95gmBukmnmBewUZDOSwetPx8LNsQAJrQgYbZk-SQnLb6lsggSH7AIrJUT3SGvIq_793LIpjOKdx-YNM9zydULPNVu0AqDePtwLpth6EwuoCrwTaxlDX5Hlo45DPOCq3rOGIewO1zlQsrbX4OwqJP0MhQsKF2m65nh22Io8xHUAEMyJK-M4ji0aHLCjc1qKcNwcZHLcP3AzSyJ1Zv1E7uxYn_fS8_vdo4MrJPkfXKR13RQUYZ9RxKpKmdPoinBWqbG144qUCW_c3PHe2s_fIEh7KugKA3SMONkfm52pH-vXqiyZAADj7rv6M7w6JOGHKlb6Weq6z6mFZiGqmNl8z-kYjtr41hDYcNt_3oTtsJemEeyMkR1VKNO7giY_PjcmOXe-JSWgvIySceuP4wQPhbELODrPH08ThgzJEstnSPoz9xA8HgaqlGbED85QLfF4IOwuuumGiMdOLVo_VNxs0kdpIDLNL53_egpSh5xpLcigM-Kd3C3tdcs60fVq75TFAy_EFDgkalLvLIvoE.UC4_3dKCgDmW1pBqoNNAMg",
              TokenType: "Bearer"
            }
            return g;
          }
        }
    }
</script>

